/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M6 9l6 6l6 -6", "key": "svg-0" }]];
const IconChevronDown = createReactComponent("outline", "chevron-down", "ChevronDown", __iconNode);

export { __iconNode, IconChevronDown as default };
//# sourceMappingURL=IconChevronDown.mjs.map
